import { SystemStatsCard } from '../components/dashboard/SystemStatsCard'

export default function DashboardView() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-3xl font-bold text-gray-900">Dashboard de Visualización</h1>
          <p className="mt-2 text-sm text-gray-600">
            Datos forestales y ambientales de Castilla y León
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Estadísticas del Sistema */}
        <SystemStatsCard />

        {/* Información Adicional */}
        <div className="mt-8 bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Acerca del Sistema</h2>
          <div className="prose prose-sm text-gray-600">
            <p className="mb-4">
              Este panel de visualización muestra estadísticas en tiempo real del sistema de gestión de dashboards ambientales de Castilla y León.
            </p>
            <div className="grid md:grid-cols-2 gap-6 mt-6">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Funcionalidades Disponibles</h3>
                <ul className="list-disc list-inside space-y-1 text-sm">
                  <li>Creación y gestión de dashboards personalizados</li>
                  <li>30 tipos de componentes de visualización</li>
                  <li>Sistema de tracking de visitas</li>
                  <li>Constructor visual drag-and-drop</li>
                  <li>Compartir dashboards públicos</li>
                  <li>Reportes automáticos por email</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Datos Disponibles</h3>
                <ul className="list-disc list-inside space-y-1 text-sm">
                  <li>191 municipios de Palencia con coordenadas GPS</li>
                  <li>34 mancomunidades</li>
                  <li>Datos forestales completos (existencias, especies, etc.)</li>
                  <li>Información territorial y ambiental</li>
                  <li>Histórico de visitas y análisis</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Accesos Rápidos */}
        <div className="mt-8 grid md:grid-cols-3 gap-6">
          <a
            href="#/admin/dashboards"
            className="block bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Gestionar Dashboards</h3>
              <span className="text-3xl">📊</span>
            </div>
            <p className="text-sm text-gray-600">
              Crear, editar y publicar dashboards personalizados
            </p>
          </a>

          <a
            href="#/builder/components"
            className="block bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Componentes</h3>
              <span className="text-3xl">🧩</span>
            </div>
            <p className="text-sm text-gray-600">
              Explorar y gestionar componentes de visualización
            </p>
          </a>

          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Ver Landing Público</h3>
              <span className="text-3xl">🌐</span>
            </div>
            <p className="text-sm text-gray-600">
              Vista pública del dashboard predeterminado
            </p>
          </a>
        </div>

        {/* Footer Info */}
        <div className="mt-8 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-6 border border-purple-100">
          <div className="flex items-start gap-4">
            <span className="text-4xl">💡</span>
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">¿Cómo empezar?</h3>
              <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
                <li>Ve a <strong>Builder → Componentes</strong> para crear componentes de visualización</li>
                <li>Luego ve a <strong>Builder → Dashboards</strong> para crear un nuevo dashboard</li>
                <li>Agrega componentes al dashboard usando el editor visual</li>
                <li>Publica el dashboard para que sea visible públicamente</li>
                <li>Comparte el enlace público con quien quieras</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
